export {
  changeTerm as changeBrowserTerm,
  toggleType as toggleBrowserType,
  setRange as changeBrowserRange,
  hilight as hilightBrowserItem,
  load as loadBrowserItems,
  setType as setBrowserType,
  setDistrict as setBrowserDistrict,
  reset
} from './modules/browser';

export {
  fetchObject,
  unsetCenter,
  toggleBasket
} from './modules/objects';

export {
  loadCart,
  addRow,
  removeRow,
  openCart,
  closeCart,
  checkout as checkoutCart
} from './modules/cart';

export {
  loadPage as loadNewsPage,
  fetchItem as fetchNewsItem,
} from './modules/news';

export { load as loadGallery } from './modules/gallery';

export {
  calculate
} from './modules/basket';

export {
  loadMeta
} from './modules/meta';

export {
  logIn,
  logInFromResponse,
  loadUser,
  logOut,
  setCompany
} from './modules/user';

export const ADD_ENTITIES = 'ADD_ENTITIES';
export const SET_ENTITIY = 'SET_ENTITIY';

export const addEntities = entities => ({
  type: ADD_ENTITIES,
  payload: entities
});

export const setEnitity = (id, collection, entity) => ({
  type: SET_ENTITIY,
  entity,
  id,
  collection
});



// WEBPACK FOOTER //
// ./src/redux/actions.js